import { defineMessages } from 'react-intl'

export const playerMessages = defineMessages({
    skip: { id: 'player.skip', defaultMessage: 'Skip' },
    continueButton: { id: 'player.continue', defaultMessage: 'Continue' },
    finish: { id: 'player.finish', defaultMessage: 'Finish' },
    tryAgain: { id: 'player.try.again', defaultMessage: 'Try Again' },
    submit: { id: 'player.submit', defaultMessage: 'Submit' },
    check: { id: 'player.check', defaultMessage: 'Check' },
    reset: { id: 'player.reset', defaultMessage: 'Reset' },
    undo: { id: 'player.undo', defaultMessage: 'Undo' },
    score: { id: 'player.score', defaultMessage: 'Score' },
    stars: { id: 'player.stars', defaultMessage: 'Stars' },
    correct: { id: 'player.correct', defaultMessage: 'Correct' },
    incorrect: { id: 'player.incorrect', defaultMessage: 'Incorrect' },
    answered: { id: 'player.answered', defaultMessage: 'Answered' },
    correctFeedback: { id: 'player.correct.feedback', defaultMessage: 'Correct!' },
    incorrectFeedback: { id: 'player.incorrect.feedback', defaultMessage: 'Incorrect' },
    lessonComplete: { id: 'player.lesson.complete', defaultMessage: 'Lesson Complete!' },
    greatJob: { id: 'player.great.job', defaultMessage: 'Great job!' },
    keepPracticing: { id: 'player.keep.practicing', defaultMessage: 'Keep practicing!' },
    xpBadge: { id: 'player.xp.badge', defaultMessage: '+{xp} XP' },
    listening: { id: 'player.listening', defaultMessage: 'Listening...' },
    tapAnswerOrSkip: { id: 'player.tap.answer.or.skip', defaultMessage: 'Tap an answer or skip' },
    startingMic: { id: 'player.starting.mic', defaultMessage: 'Starting mic...' },
    optionNumber: { id: 'player.option.number', defaultMessage: 'Option {number}' },
    fillInBlanks: { id: 'player.fill.in.blanks', defaultMessage: 'Fill in the blanks' },
    readContentContinue: {
        id: 'player.read.content.continue',
        defaultMessage: 'Read the content and continue when you are ready',
    },
    playAudio: { id: 'player.play.audio', defaultMessage: 'Play audio' },
    writeAnswerPlaceholder: {
        id: 'player.write.answer.placeholder',
        defaultMessage: 'Write your answer here...',
    },
    evaluatingAnswer: { id: 'player.evaluating.answer', defaultMessage: 'Evaluating your answer...' },
    couldNotEvaluate: {
        id: 'player.could.not.evaluate',
        defaultMessage: 'Could not evaluate your answer. Please try again.',
    },
    answerSubmitted: { id: 'player.answer.submitted', defaultMessage: 'Answer submitted' },
    matchWith: { id: 'player.match.with', defaultMessage: 'Match with' },
    selectOne: { id: 'player.select.one', defaultMessage: 'Select one' },
    space: { id: 'player.space', defaultMessage: 'space' },
    micPermissionError: {
        id: 'player.mic.permission.error',
        defaultMessage: 'Could not start recording. Please check microphone permissions.',
    },
    practicePronunciation: {
        id: 'player.practice.pronunciation',
        defaultMessage: 'Practice my pronunciation',
    },
    stopRecording: { id: 'player.stop.recording', defaultMessage: 'Stop recording' },
    errorNoStartingNode: {
        id: 'player.error.no.starting.node',
        defaultMessage: 'Unable to start lesson — no valid starting node found.',
    },
    unsupportedNodeType: {
        id: 'player.error.unsupported.node',
        defaultMessage: 'Unsupported node type: {type}',
    },
    tryAgainFeedback: { id: 'player.try.again.feedback', defaultMessage: 'Try again' },
    matchedProgress: { id: 'player.matched.progress', defaultMessage: '{matched} / {total} matched' },
    speechCredentialsError: {
        id: 'player.speech.credentials.error',
        defaultMessage: 'Failed to fetch speech recognition credentials',
    },
    characters: { id: 'player.characters', defaultMessage: '{count} characters' },
    words: { id: 'player.words', defaultMessage: '{count} words' },
    cefrLevelAppropriate: { id: 'player.cefr.level.appropriate', defaultMessage: 'CEFR Level Appropriate' },
    belowCefrLevel: { id: 'player.below.cefr.level', defaultMessage: 'Below CEFR Level' },
})
